import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { scrollToTop, } from 'shared';
import { selectors as flexFinalizeSelectors } from '../../flex-finalize/reducer';
import { selectors } from '../reducer';
import ApprovalAdvantage from './ApprovalAdvantage';
import ApprovalCard from './ApprovalCard';
import ApprovalFlex from './ApprovalFlex';
import ApprovalInstallment from './ApprovalInstallment';
function Approval({ personalInfo, practice, approvedApplication, lenderName, }) {
    const { applicationServiceProviderPriority } = approvedApplication;
    const signingUrl = useSelector((state) => flexFinalizeSelectors.signingUrl(state));
    useEffect(() => {
        scrollToTop();
    }, []);
    return (_jsxs(_Fragment, { children: [lenderName === 'Imprint' && (_jsx(ApprovalAdvantage, { practice: practice, approvedApplication: approvedApplication })), lenderName === 'ACI' && (_jsx(ApprovalFlex, { practice: practice, approvedApplication: approvedApplication })), applicationServiceProviderPriority.productType === 'line_of_credit' && (_jsx(ApprovalCard, { personalInfo: personalInfo, practice: practice, approvedApplication: approvedApplication, signingUrl: signingUrl })), lenderName !== 'Imprint' &&
                lenderName !== 'ACI' &&
                applicationServiceProviderPriority.productType === 'installment' && (_jsx(ApprovalInstallment, { personalInfo: personalInfo, practice: practice, approvedApplication: approvedApplication }))] }));
}
function mapStateToProps(state) {
    return {
        approvedApplication: selectors.approvedApplication(state),
        practice: selectors.practice(state),
        personalInfo: selectors.personalInfo(state),
        lenderName: selectors.lenderName(state),
    };
}
const mapDispatchToProps = {};
export default compose(connect(mapStateToProps, mapDispatchToProps))(Approval);
